import classNames from 'classnames';
import { MouseEventHandler, ReactNode } from 'react';

import CardContainer from './CardContainer';

import styles from '../../styles/cards/over-card.module.css';

const defaultRatio = 4 / 3;

interface OverCardProps {
    theme?: CardTheme | 'none' | null;
    size?: string | null;
    fillThumbnail?: boolean;
    brand?: BrandHandle | null;
    href?: string | null;
    thumbnail?: ReactNode | null;
    thumbnailRatio?: number;
    width?: number | string | null;
    children?: ReactNode | null;
    className?: string | null;
    thumbnailClassName?: string | null;
    labelClassName?: string | null;
    innerClassName?: string | null;
    onClick?: MouseEventHandler<HTMLAnchorElement> | null;
}
function OverCard({
    theme = null,
    size = null,
    fillThumbnail = false,
    brand = null,
    href = null,
    thumbnail = null,
    thumbnailRatio = defaultRatio,
    width = null,
    children = null,
    className = null,
    thumbnailClassName = null,
    labelClassName = null,
    innerClassName = null,
    onClick = null,
}: OverCardProps) {
    const thumbnailStyle = {
        width: width || '100%',
        height: fillThumbnail || thumbnailRatio === null ? '100%' : width / thumbnailRatio,
        paddingBottom:
            width === null && !fillThumbnail && thumbnailRatio !== null
                ? `${(1 / thumbnailRatio) * 100}%`
                : null,
    };
    const Element = href !== null || onClick !== null ? 'span' : 'div';
    const cardInner = (
        <Element
            className={classNames([
                styles.inner,
                {
                    [innerClassName]: innerClassName !== null,
                },
            ])}
        >
            <Element
                className={classNames([
                    styles.thumbnail,
                    {
                        'contain-size': thumbnailStyle.paddingBottom !== null,
                        [thumbnailClassName]: thumbnailClassName !== null,
                    },
                ])}
                style={thumbnailStyle}
            >
                {thumbnail}
                <Element
                    className={classNames([
                        styles.label,
                        {
                            [labelClassName]: labelClassName !== null,
                        },
                    ])}
                >
                    {children}
                </Element>
            </Element>
        </Element>
    );
    return (
        <CardContainer
            href={href}
            onClick={onClick}
            brand={brand}
            presentation="over"
            theme={theme}
            size={size}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {cardInner}
        </CardContainer>
    );
}
export default OverCard;
